import { Component, ContentChild, Input } from '@angular/core';

import { BadgeComponent } from '../../common/badge/badge.component';
import { IconHelpComponent } from '../../common/icon-help/icon-help.component';
import { IconComponent } from '../../common/icon/icon.component';
import { ComponentVariant, Variants } from '../../common/variant/variant';

@Component({
  selector: 'rt-heading',
  styleUrls: ['./heading.component.less'],
  templateUrl: './heading.component.html',
  host: {
    '[class.has-icon]': 'icon',
    '[class.truncated]': 'truncated',
    '[class.has-text-color-darker]': 'hasTextColorDarker',
    '[class.has-text-color-red]': 'hasTextColorRed',
    '[class.text-color-light]': 'hasTextColorLight',
    '[class.white-text]': 'hasWhiteText',
    '[class.correct-line-height]': 'hasCorrectLineHeight',
    '[class]': 'variant',
    '[class.text-wrap]': 'textWrap',
  },
})
export class HeadingComponent {
  public static readonly VARIANTS: Variants = [
    'heading',
    [
      'heading',
      'subheading',
      'large',
      'large-x',
      'large-xx',
      'large-xxx',
      'uppercased',
      'block',
      'space-bottom',
      'icon-right',
      'text-color',
      'text-color-light',
      'small',
      'light',
      'normal',
      'dark',
      'align-center',
      'size-default',
      'lighter',
    ],
  ];
  @ComponentVariant(HeadingComponent.VARIANTS)
  @Input()
  public variant: string;

  @ContentChild(IconComponent)
  public icon: IconComponent;
  @ContentChild(IconHelpComponent, /* TODO: add static flag */ { static: true })
  public iconHelp: IconHelpComponent;
  @ContentChild(BadgeComponent, /* TODO: add static flag */ { static: false })
  public badge: BadgeComponent;

  @Input() public showIcon: boolean = true;
  @Input() public truncated: boolean = false;
  @Input() public hasTextColorDarker: boolean = false;
  @Input() public hasWhiteText: boolean = false;
  @Input() public hasCorrectLineHeight: boolean = false;
  @Input() public hasTextColorLight: boolean = false;
  @Input() public hasTextColorRed: boolean = false;
  @Input() public textWrap: boolean = false;
}
